export const strings = {
    'Carousel_Next': "下一個",
    'Carousel_Previous': "上一個",
    'Carousel_Slide': "投影片 {0}",
    'Carousel_SlideIndicators': "選擇要顯示的投影片",
    'ChainOfThought_Complete': "完成",
    'DataGrid_NoRowsSelected': "No rows selected",
    'DataGrid_ResizeColumn': "Resize {column} column",
    'DataGrid_ResizeColumnValueText': "{width} pixels",
    'DataGrid_ResizeModeEntered': "Resizing {column} column. Use arrow keys.",
    'DataGrid_RowsSelected': "{count} of {total} rows selected",
    'DataGrid_SelectAllRows': "Select all rows",
    'DataGrid_SelectRow': "Select row",
    'DataGrid_SortAscending': "Sort ascending",
    'DataGrid_SortDescending': "Sort descending",
    'DataGrid_SortedByAscending': "Sorted by {column} ascending",
    'DataGrid_SortedByDescending': "Sorted by {column} descending",
    'DynamicTab_CloseHint': "使用關閉按鈕或快顯功能表移除索引標籤",
    'DynamicTab_CloseTab': "關閉索引標籤",
    'DynamicTab_Modified': "已修改",
    'DynamicTabList_CloseAll': "關閉所有索引標籤",
    'DynamicTabList_CloseUnmodified': "關閉未修改的索引標籤",
    'DynamicTabList_ManageTabs': "管理索引標籤",
    'Modal_Back': "返回",
    'Modal_Close': "關閉",
    'Modal_Dismiss': "關閉",
    'Modal_Done': "完成",
    'Modal_Next': "下一個",
    'Modal_PrimaryAction': "確定",
    'Modal_TryLater': "請稍後再試",
    'Pagination_FirstPage': "第一頁",
    'Pagination_LastPage': "最後頁面",
    'Pagination_Navigation': "分頁",
    'Pagination_Next': "下一個",
    'Pagination_NextPage': "下一頁",
    'Pagination_PageButton': "第 {page} 頁",
    'Pagination_PageNumbers': "頁數",
    'Pagination_PageOption': "第 {page} 頁，共 {total} 頁",
    'Pagination_PageSummary': "頁面摘要",
    'Pagination_Previous': "上一個",
    'Pagination_PreviousPage': "上一頁",
    'RangeSlider_InputLabelEnd': "Maximum value",
    'RangeSlider_InputLabelStart': "Minimum value",
    'RangeSlider_MaxThumbLabel': "Maximum",
    'RangeSlider_MinThumbLabel': "Minimum",
    'SearchBox_Clear': "清除",
    'Slider_InputLabel': "Value",
    'VariablePickerField_ConnectionName': "Connection name",
    'VariablePickerField_ConnectionType': "Connection type",
    'VariablePickerField_ItemName': "Item name",
    'VariablePickerField_ItemType': "Item type",
    'VariablePickerField_LearnMore': "Learn more",
    'VariablePickerField_Loading': "Loading",
    'VariablePickerField_PickVariable': "Pick a variable",
    'VariablePickerField_ResolveError_ActiveValueSetNotFound_Description': "The active value set configured for this variable library does not exist. Update the active value set and try again.",
    'VariablePickerField_ResolveError_ActiveValueSetNotFound_Title': "Active value set not found",
    'VariablePickerField_ResolveError_Generic_Description': "We couldn't resolve this variable reference. Try again.",
    'VariablePickerField_ResolveError_Generic_Title': "Couldn't resolve reference",
    'VariablePickerField_ResolveError_InvalidReferenceFormat_Description': "This variable reference isn't formatted correctly. Fix the reference and try again.",
    'VariablePickerField_ResolveError_InvalidReferenceFormat_Title': "Reference format is invalid",
    'VariablePickerField_ResolveError_InvalidReferenceInlineTypeNotAllowed_Description': "This variable reference doesn't support inline type specification. Remove the type specification and try again.",
    'VariablePickerField_ResolveError_InvalidReferenceInlineTypeNotAllowed_Title': "Type specification is not allowed",
    'VariablePickerField_ResolveError_InvalidVariableDefinition_Description': "One or more variable definitions in this variable library are invalid. Fix the variable definitions and try again.",
    'VariablePickerField_ResolveError_InvalidVariableDefinition_Title': "Variable definition is invalid",
    'VariablePickerField_ResolveError_InvalidVariableOverride_Description': "One or more variable overrides are invalid. Fix the override values and try again.",
    'VariablePickerField_ResolveError_InvalidVariableOverride_Title': "Variable override is invalid",
    'VariablePickerField_ResolveError_ReferencedEntityAccessDenied_Description': "You do not have read permission for the referenced item. Request access and try again.",
    'VariablePickerField_ResolveError_ReferencedEntityAccessDenied_Title': "Access to referenced item denied",
    'VariablePickerField_ResolveError_ReferencedEntityNotFound_Description': "The referenced item was not found. Check that the item still exists and try again.",
    'VariablePickerField_ResolveError_ReferencedEntityNotFound_Title': "Referenced item not found",
    'VariablePickerField_ResolveError_ReferencedEntityNotFoundOrAccessDenied_Description': "The referenced connection was not found, or you do not have permission to read it. Check the connection and your access, then try again.",
    'VariablePickerField_ResolveError_ReferencedEntityNotFoundOrAccessDenied_Title': "Referenced connection not found or access denied",
    'VariablePickerField_ResolveError_TypeMismatch_Description': "The referenced variable value type does not match the requested type. Update the requested type or the variable value and try again.",
    'VariablePickerField_ResolveError_TypeMismatch_Title': "Variable type mismatch",
    'VariablePickerField_ResolveError_UnexpectedError_Description': "We couldn't resolve the referenced item. Try again.",
    'VariablePickerField_ResolveError_UnexpectedError_Title': "Something went wrong",
    'VariablePickerField_ResolveError_VariableLibraryCorrupted_Description': "This variable library is corrupted, so the system can't resolve it right now. Contact support if the issue continues.",
    'VariablePickerField_ResolveError_VariableLibraryCorrupted_Title': "Variable library is corrupted",
    'VariablePickerField_ResolveError_VariableLibraryNotFound_Description': "The variable library was not found, or you do not have permission to read it. Check the reference and your access, then try again.",
    'VariablePickerField_ResolveError_VariableLibraryNotFound_Title': "Variable library not found",
    'VariablePickerField_ResolveError_VariableLibraryReferenceIsAmbiguous_Description': "We found multiple variable library items that match this reference. Use a more specific reference and try again.",
    'VariablePickerField_ResolveError_VariableLibraryReferenceIsAmbiguous_Title': "Variable library reference is ambiguous",
    'VariablePickerField_ResolveError_VariableLibraryReferenceIsMissing_Description': "This reference is missing its variable library. Provide a complete reference and try again.",
    'VariablePickerField_ResolveError_VariableLibraryReferenceIsMissing_Title': "Variable library reference is missing",
    'VariablePickerField_ResolveError_VariableNotFound_Description': "The referenced variable was not found in this variable library. Verify the variable name and try again.",
    'VariablePickerField_ResolveError_VariableNotFound_Title': "Variable not found",
    'VariablePickerField_Type': "Type",
    'VariablePickerField_Value': "Value",
    'VariablePickerField_VariableInfo': "Variable info",
    'VariablePickerField_ViewVariables': "View variables",
    'VariablePickerField_WorkspaceName': "Workspace name",
};
